import PageBox from "PFComponents/box/page_box";
import { PillTabs } from "PFComponents/tabs/pill_tabs";
import { Typography } from "PFComponents/typography";
import { LocalisationKeys } from "PFTypes";
import { Account } from "PFTypes/account";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./localisation.module.scss";
import { LocalisationExport } from "./localisation_export";
import { LocalisationKeysList } from "./localisation_keys_list";

type LocalisationProps = {
  account?: Account;
};

export const Localisation = ({ account }: LocalisationProps) => {
  const { t } = useTranslation("admin", { keyPrefix: "localisation" });

  const [selectedTab, selectTab] = useState<LocalisationKeys>(LocalisationKeys.CustomTypes);

  const TABS = useMemo(
    () => [
      { id: LocalisationKeys.CustomTypes, label: t(`tabs.${LocalisationKeys.CustomTypes}`) },
      { id: LocalisationKeys.Filters, label: t(`tabs.${LocalisationKeys.Filters}`) },
      { id: LocalisationKeys.OrderOptions, label: t(`tabs.${LocalisationKeys.OrderOptions}`) },
      { id: LocalisationKeys.AccountTemplates, label: t(`tabs.${LocalisationKeys.AccountTemplates}`) }
    ],
    [t]
  );

  return (
    <main>
      <header className={css.header}>
        <Typography variant="h1">{t("header")}</Typography>
        <Typography variant="h4" className={css.subheader}>
          {t("showingFor", { account: account?.name })}
        </Typography>
      </header>
      <PageBox className={css.pageBox}>
        <div className={css.toolbar}>
          <PillTabs<LocalisationKeys> tabs={TABS} selectedId={selectedTab} onTabClick={selectTab} />
          <LocalisationExport accountId={account?.id} localisationKey={selectedTab} />
        </div>
        <LocalisationKeysList account={account} localisationKey={selectedTab} />
      </PageBox>
    </main>
  );
};
